import RemovableGooglePlace from "components/Removables/RemovableGooglePlace";
import React from "react";
import { GooglePlaceInput } from "./GooglePlaceInput";
import { useValidateIsAlwaysValid, useValidateIsNotNull } from "formvalidation/hooks";
import { GooglePlaceState } from "shared/utils/fieldsHelper/groundFields";

interface Props {
  value: GooglePlaceState;
  onPlaceSelected: (place: GooglePlaceState) => void;
  calledFrom: "train" | "ground";
  placeType?: server.dto.GooglePlaceTypes;
  focusOnMount?: boolean;
  isRequired?: boolean;
  validatorKey: string;
}

export const GooglePlaceInputWithValue = (props: Props) => {
  const validation = props.isRequired ?
    useValidateIsNotNull({
      key: props.validatorKey,
      title: props.validatorKey,
      value: props.value,
    }) :
    useValidateIsAlwaysValid(props.validatorKey, props.validatorKey);

  return <div className="flex-column gap-small">
    {props.value && <RemovableGooglePlace
      value={props.value}
      onChange={() => props.onPlaceSelected(null)}
      readonly={false}
      error={false}
    />}
    {!props.value && <GooglePlaceInput
      calledFrom={props.calledFrom}
      placeType={props.placeType}
      onPlaceSelected={props.onPlaceSelected}
      focusOnMount={props.focusOnMount}
      hasError={validation.error.hasError}
    />}
  </div>
}